import React from 'react';
import Swal from 'sweetalert2';
import '../layout.css';
import { sidebarData } from '../../services/staticData';
import { useLocation, useNavigate } from 'react-router-dom';
import { TbLogout } from 'react-icons/tb';
import { IoMdClose } from 'react-icons/io';
import cloud from '../../assests/download.png';

const Sidebar = ({ toggleOpen, setToggleOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const role = localStorage.getItem('role');

    const logoutHandle = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, log out!"
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem('token');
                localStorage.removeItem('role');
                navigate('/');
                Swal.fire("Logged Out!", "You have been successfully logged out.", "success");
            }
        });
    };

    // Filter sidebar items based on role
    const filteredSidebarData = role === 'agent'
        ? sidebarData.filter((_, i) => i === 5 || i === 7) // Show only index 5 and 7 for agents
        : sidebarData;

    return (
        <div className="side-container">
            <div className="side-logo">
                <img src={cloud} alt="Logo" />
                <div className="icon-close-mobile" onClick={() => setToggleOpen(false)}>
                    <IoMdClose style={{ fontSize: "2rem", color: "white" }} />
                </div>
            </div>
            {filteredSidebarData.map((el, i) => (
                <div
                    key={i}
                    className={`side-tab ${location.pathname === el.routes ? "active-side-tab" : ""}`}
                    onClick={() => {
                        navigate(el.routes);
                        setToggleOpen(false);
                    }}
                >
                    {el.icon} {el.name}
                </div>
            ))}
            <div className={`side-tab ${location.pathname === '/' ? 'active-side' : ''}`} onClick={logoutHandle}>
                <TbLogout className="tblogout" /> Log Out
            </div>
        </div>
    );
};

export default Sidebar;
